export default __webpack_public_path__ + "static/assets/93636feeb5a6d3d800c14ecd0dcb9a6c.svg";